module.exports = __webpack_public_path__ + "img/bg2.09097318.png";